/*
 * @Author: wp
 * @Date: 2023-01-04 11:02:39
 * @Descripttion:
 */
import LoginRouter from './login.js'
import AccountRouter from './account'
import Home from '@/pages/index.vue'
import GameList from '~/pages/buy/gameList/index.vue'
import GoodsList from '~/pages/buy/goodsList/index.vue'
import SelectGame from '~/pages/release/selectGame'
import SelectServer from '~/pages/release/selectServer'
import SelectCategory from '~/pages/release/selectCategory'
import EditCategory from '~/pages/release/editCategory'
import EditAccount from '~/pages/release/editGoodsInfo'
import Success from '~/pages/release/success'
import ServicesList from '~/pages/home/services/lists/index.vue'
import Intermediary from '~/pages/home/article/Intermediary.vue'
import BlackSign from '~/pages/home/article/blackSign.vue'
import purchaseGuide from '~/pages/home/article/purchaseGuide.vue'
import SalesGuide from '~/pages/home/article/salesGuide.vue'
import Article from '~/pages/home/article/details.vue'
import ArticleList from '~/pages/home/article/lists.vue'
import HelpCenter from '~/pages/home/helpCenter/index.vue'
import Advise from '~/pages/home/advise/index.vue'
import ServicesGames from '~/pages/home/services/games' //帮助中心咨询客服游戏列表
import HelpCustomerService from '~/pages/home/services/lists' // 帮助中心咨询客服列表
import Business from '~/pages/home/business/index.vue'
import CompanyProfile from '~/pages/home/companyProfile/index.vue'
import GoodsDetail from '~/pages/buy/goodsDetails/index.vue'
import GeneralGoodsDetails from '~/pages/buy/generalGoodsDetails/index.vue'
import MoreDeals from '~/pages/buy/moreDeals/index.vue'
import MoreList from '~/pages/buy/moreList/index.vue'
import Complaints from '~/pages/home/complaints/index.vue'
import Tver from '~/pages/home/tver/index.vue'
import ReGoodsDetail from '~/pages/buy/goodsDetails/reGoodsDetail.vue'
import Confirm from '~/pages/buy/confirmOrder/confirm/index.vue'
import orderInfoConfirm from '~/pages/buy/confirmOrder/orderInfoConfirm/index.vue'
import onlinePay from '~/pages/buy/confirmOrder/orderInfoConfirm/onlinePay.vue'
import fullPayment from '~/pages/buy/confirmOrder/orderInfoConfirm/fullPayment.vue'
import generalGoodsInfoConfirm from '~/pages/buy/confirmOrder/orderInfoConfirm/generalGoodsInfoConfirm.vue'
import Payment from '~/pages/buy/confirmOrder/payment/index.vue'
import paymentCallback from '~/pages/buy/confirmOrder/paymentCallback/index.vue'
import ContactInfo from '~/pages/buy/confirmOrder/contactInfo/index.vue'
import GameInformation from '~/pages/gameInformation/index.vue'
import ArticleDetails from '~/pages/gameInformation/articleDetails/index.vue'
import Download from '~/pages/home/app/index.vue'
import DownloadBili from '~/pages/home/app/downloadBili.vue'
import DownloadPc from '~/pages/home/app/downloadPc.vue'
import Questionnaire from '~/pages/center/questionnaire/index.vue'
import BannerDtl from '~/pages/home/bannerDtl/index.vue'
import recentConsultation from '~/pages/home/recentConsultation/index.vue'
import recentConsultationDtl from '~/pages/home/recentConsultation/dtl/index.vue'
import recentConsultationSubmit from '~/pages/home/recentConsultation/submit/index.vue'
import License from '~/pages/home/license/index.vue'
import iOSAuthorized from '~/pages/home/iOSAuthorized/index.vue'

import TradeList from '~/pages/home/tradeList/index.vue' //交易榜
import YesterdayDeal from '~/pages/home/yesterdayDeal/index.vue' //昨日成交

export default [
    // 登录相关路由
    ...LoginRouter,
    ...AccountRouter,
    // {
    //   path: "/",
    //   redirect: "/home",
    // },
    {
        path: '/',
        name: 'home',
        meta: {
            title: '首页'
        },
        component: Home
    },
    {
        path: '/gameList',
        name: 'gameList',
        meta: {
            title: '全部游戏'
        },
        component: GameList
    },
    {
        path: '/goodsList/:gameId/:goodsCatalogueId?/:from?/:keyReason?',
        name: 'goodsList',
        meta: {
            title: '商品列表'
        },
        component: GoodsList
    },
    {
        path: '/selectGame',
        name: 'selectGame',
        component: SelectGame,
        meta: { belongGroupPath: '/release', title: '挂牌代售' }
    },
    {
        path: '/selectCategory',
        name: 'selectCategory',
        component: SelectCategory,
        meta: { belongGroupPath: '/release', title: '选择商品类别' }
    },
    {
        path: '/selectServer',
        name: 'selectServer',
        component: SelectServer,
        meta: { title: '选择区服', belongGroupPath: '/release' }
    },
    {
        path: '/editAccount',
        name: 'editAccount',
        component: EditAccount,
        meta: { title: '填写账号商品信息', belongGroupPath: '/release' }
    },
    {
        path: '/editCategory',
        name: 'editCategory',
        component: EditCategory,
        meta: { title: '填写商品类别信息', belongGroupPath: '/release' }
    },
    {
        path: '/success',
        name: 'success',
        component: Success,
        meta: { title: '发布成功', belongGroupPath: '/release' }
    },
    {
        path: '/Intermediary',
        name: 'Intermediary',
        meta: {
            title: '中介担保'
        },
        component: Intermediary
    },
    {
        path: '/blackSign',
        name: 'blackSign',
        meta: {
            title: '黑号查询'
        },
        component: BlackSign
    },
    {
        path: '/articleList/:type',
        name: 'articleList',
        meta: {
            title: '文章列表',
            keepAlive: true,
            reload: false
        },
        component: ArticleList
    },
    {
        path: '/article/:id',
        name: 'article',
        meta: {
            title: '文章详情'
        },
        component: Article
    },
    {
        path: '/helpCenter/:id?',
        name: 'helpCenter',
        meta: {
            title: '帮助中心'
        },
        component: HelpCenter
    },
    {
        path: '/advise',
        name: 'advise',
        meta: {
            title: '投诉与建议'
        },
        component: Advise
    },
    {
        path: '/services',
        name: 'services',
        component: ServicesGames,
        meta: { title: '游戏列表' }
    },
    {
        path: '/servicesList/:id/:goodsCatalogueId/:name/:buyType/:type?',
        name: 'servicesList',
        component: ServicesList,
        meta: { title: '客服列表' }
    },
    // {
    //   path: "/services",
    //   redirect: "/services",
    //   component: Services,
    //   children: [
    //     {
    //       path: "/services",
    //       name: "services",
    //       component: ServicesGames,
    //     },
    //     {
    //       path: "/helpCustomerService/:id/:name",
    //       name: "helpCustomerService",
    //       component: HelpCustomerService,
    //     },
    //   ],
    // },
    {
        path: '/business/:title?',
        name: 'business',
        meta: {
            title: '业务介绍'
        },
        component: Business
    },
    {
        path: '/qyjs/:title?',
        name: 'qyjs',
        component: CompanyProfile,

        meta: {
            title: '企业介绍'
        }
    },
    {
        path: '/license',
        name: 'license',
        component: License,
        meta: {
            title: '企业介绍'
        }
    },
    {
        path: '/iOSAuthorized',
        name: 'iOSAuthorized',
        component: iOSAuthorized,
        meta: {
            title: 'iOS授权'
        }
    },
    {
        // 路由传参接收，以'/'分割模式，路由后加':goodsNo(参数名称)'，如多个参数就配置多个，如此参数为非必传参数则在参数名后加'？'，否则路由跳转会404
        path: '/goodsDetails/:goodsNo/:goodsCatalogueId?',
        name: 'goodsDetails',
        component: GoodsDetail,
        meta: {
            title: '商品详情'
        }
    },
    {
        // 路由传参接收，以'/'分割模式，路由后加':goodsNo(参数名称)'，如多个参数就配置多个，如此参数为非必传参数则在参数名后加'？'，否则路由跳转会404
        path: '/generalGoodsDetails/:goodsNo/:goodsCatalogueId?',
        name: 'generalGoodsDetails',
        component: GeneralGoodsDetails,
        meta: {
            title: '商品详情'
        }
    },
    {
        path: '/confirmOrder/confirm',
        name: 'confirmOrder',
        component: Confirm,
        meta: { title: '确认订单' }
    },
    {
        path: '/confirmOrder/orderInfoConfirm',
        name: 'orderInfoConfirm',
        component: orderInfoConfirm,
        meta: { title: '订单信息确认' }
    },
    {
        path: '/confirmOrder/onlinePay',
        name: 'onlinePay',
        component: onlinePay,
        meta: { title: '订单信息确认' }
    },
    {
        path: '/confirmOrder/fullPayment',
        name: 'fullPayment',
        component: fullPayment,
        meta: { title: '订单信息确认' }
    },
    {
        path: '/confirmOrder/generalGoodsInfoConfirm',
        name: 'generalGoodsInfoConfirm',
        component: generalGoodsInfoConfirm,
        meta: { title: '自选商品信息确认' }
    },
    {
        path: '/confirmOrder/payment',
        name: 'paymentOrder',
        component: Payment,
        meta: { title: '支付方式' }
    },
    {
        path: '/confirmOrder/paymentCallback',
        name: 'paymentCallback',
        component: paymentCallback,
        meta: { title: '支付结果' }
    },
    {
        path: '/confirmOrder/contactInfo',
        name: 'contactInfo',
        component: ContactInfo,
        meta: { title: '联系方式', keepAlive: true }
    },
    {
        path: '/more',
        name: 'more',
        component: MoreDeals,
        meta: {
            title: '更多成交'
        }
    },
    {
        path: '/moreList',
        name: 'moreList',
        component: MoreList,
        meta: { title: '每日成交' }
    },
    {
        path: '/complaints',
        name: 'complaints',
        component: Complaints,
        meta: { title: '投诉与建议' }
    },
    {
        path: '/purchaseGuide',
        name: 'purchaseGuide',
        component: purchaseGuide,
        meta: { title: '购买指南' }
    },
    {
        path: '/salesGuide',
        name: 'salesGuide',
        component: SalesGuide,
        meta: { title: '出售指南' }
    },
    {
        path: '/tver',
        name: 'tver',
        component: Tver,
        meta: { title: '更多主播' }
    },
    {
        path: '/reGoodsDetail',
        name: 'reGoodsDetail',
        component: ReGoodsDetail,
        meta: { title: '商品详情' }
    },
    {
        path: '/gameInformation/:id?/:name?',
        name: 'gameInformation',
        component: GameInformation,
        meta: { title: '游戏资讯' }
    },
    {
        path: '/articleDetails/:id/:typeId?/:type?',
        name: 'articleDetails',
        component: ArticleDetails,
        meta: { title: '游戏资讯详情' }
    },
    {
        path: '/center/questionnaire',
        name: 'questionnaire',
        component: Questionnaire,
        meta: { title: '问卷调查' }
    },
    {
        path: '/download',
        name: 'download',
        component: Download,
        meta: { title: '下载APP', keepAlive: true }
    },
    {
        path: '/biliDownload',
        name: 'biliDownload',
        component: DownloadBili,
        meta: { title: 'B站下载APP', keepAlive: true }
    },
    {
        path: '/downloadPc',
        name: 'downloadPc',
        component: DownloadPc,
        meta: { title: '下载PC', keepAlive: true }
    },
    {
        path: '/BannerDtl',
        name: 'BannerDtl',
        component: BannerDtl,
        meta: { title: '文章详情' }
    },
    {
        path: '/recentConsultation',
        name: 'recentConsultation',
        component: recentConsultation,
        meta: { title: '咨询列表' }
    },
    {
        path: '/recentConsultationDtl',
        name: 'recentConsultationDtl',
        component: recentConsultationDtl,
        meta: { title: '我咨询的' }
    },
    {
        path: '/recentConsultationSubmit',
        name: 'recentConsultationSubmit',
        component: recentConsultationSubmit,
        meta: { title: '咨询回复' }
    },
    {
        path: '/tradeList',
        name: 'tradeList',
        component: TradeList,
        meta: { title: '成交榜单' }
    },
    {
        path: '/yesterdayDeal',
        name: 'yesterdayDeal',
        component: YesterdayDeal,
        meta: { title: '昨日成交' }
    }
]
